import { useKeyboardControls } from "@react-three/drei"
import useGame from "./stores/useGame"
import { Html, useGLTF, useTexture } from '@react-three/drei'

export default function Interface()
{
    const forward = useKeyboardControls((state) => state.forward)
    const backward = useKeyboardControls((state) => state.backward)
    const leftward = useKeyboardControls((state) => state.leftward)
    const rightward = useKeyboardControls((state) => state.rightward)

    const restart = useGame((state) => state.restart)
    const phase = useGame((state) => state.phase)

    return <div className="interface">

        {/* RESTART */}
        {/* <div className="restart" onClick={ restart }>Play Again</div> */}
        { phase === 'ended' && <div className="restart" onClick={ restart }>Play Again?</div>}

    </div> 
    
}